import { z } from "zod"

export const ProductionSiteFieldDefintionSchema = z.object({
  title: z.string(),
  type: z.enum(["STRING", "NUMBER", "SELECT", "STANDARD", "MULTI_SELECT"]),
  forActivities: z.array(z.string()),
  min: z.number().optional(),
  max: z.number().optional(),
  enumValues: z.array(z.string()),
})

export const CreateProductionSiteFieldDefinitionSchema = z
  .object({
    title: z.string(),
    type: z.enum(["STRING", "NUMBER", "SELECT", "STANDARD", "MULTI_SELECT"]),
    forActivities: z.array(z.string()),
    min: z.coerce.number().optional(),
    max: z.coerce.number().optional(),
    enumValues: z.array(z.string()),
    enabledForClients: z.array(z.number()),
  })
  .refine((data) => {
    if (data.type === "SELECT" || data.type === "MULTI_SELECT") {
      return data.enumValues.length > 1
    }
    return data.forActivities.length > 0
  })

export type CreateProductionSiteFieldDefinition = z.infer<
  typeof CreateProductionSiteFieldDefinitionSchema
>

export const CreateProdSiteFieldDefParamsSchema = z.object({
  orgId: z.coerce.number(),
})
